import React, { useState } from "react";
import { Popconfirm, Form, Radio, Col, Select, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import CashForm from "./CashForm";
import AccrualCheckForm from "./AccrualCheckForm";
import UpfrontAccrualCheckForm from "./UpfrontAccrualCheckForm";

const { Text } = Typography;

const AccountingForm = (props) => {
  const {
    accountingRuleOptions,
    assetAccountOptions,
    incomeAccountOptions,
    expenseAccountOptions,
    liabilityAccountOptions,
    paymentTypeOptions,
    charges,
    setRadioChecked,
    radioChecked,
    penaltyOptions,
    onFinish,
    form,
    initialValues,
    userData,
    mapFeeTableSource,
    setMapFeeTableSource,
    configureFundTableSource,
    setConfigureFundTableSource,
    chargesOptions,
    mapPenaltyTableSource,
    setMapPenaltyTableSource,
  } = props;

  const [fundCount, setFundCount] = useState(1);
  const [feeCount, setFeeCount] = useState(0);
  const [penaltyCount, setPenaltyCount] = useState(0);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [accountingRule, setAccountingRule] = useState({});
  const [dataSource, setDataSource] = useState([
    {
      key: "0",
      paymentType: "Edward King 0",
      fundSource: "32",
    },
    {
      key: "1",
      paymentType: "Edward King 1",
      fundSource: "32",
    },
  ]);

  const filteredAccountingRuleOptions = accountingRuleOptions.filter(
    (item) => item.label !== "NONE",
  );

  console.log(radioChecked, "radioChecked");
  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={initialValues}
      style={{ margin: 30 }}
    >
      {filteredAccountingRuleOptions.map(({ value, label }) => {
        return (
          <Radio
            key={value}
            onChange={() => setRadioChecked(value)}
            checked={value === radioChecked}
            name={"accountingRule"}
          >
            {label}
          </Radio>
        );
      })}

      {radioChecked === 2 ? (
        <CashForm
          form={form}
          showAdvanced={showAdvanced}
          setShowAdvanced={setShowAdvanced}
          assetAccountOptions={assetAccountOptions}
          incomeAccountOptions={incomeAccountOptions}
          expenseAccountOptions={expenseAccountOptions}
          liabilityAccountOptions={liabilityAccountOptions}
          paymentTypeOptions={paymentTypeOptions}
          charges={charges}
          userData={userData}
          onFinish={onFinish}
          fundCount={fundCount}
          setFundCount={setFundCount}
          feeCount={feeCount}
          setFeeCount={setFeeCount}
          penaltyCount={penaltyCount}
          setPenaltyCount={setPenaltyCount}
          mapFeeTableSource={mapFeeTableSource}
          setMapFeeTableSource={setMapFeeTableSource}
          configureFundTableSource={configureFundTableSource}
          setConfigureFundTableSource={setConfigureFundTableSource}
          chargesOptions={chargesOptions}
          penaltyOptions={penaltyOptions}
          mapPenaltyTableSource={mapPenaltyTableSource}
          setMapPenaltyTableSource={setMapPenaltyTableSource}
        />
      ) : radioChecked === 3 ? (
        <AccrualCheckForm
          form={form}
          showAdvanced={showAdvanced}
          setShowAdvanced={setShowAdvanced}
          assetAccountOptions={assetAccountOptions}
          incomeAccountOptions={incomeAccountOptions}
          expenseAccountOptions={expenseAccountOptions}
          liabilityAccountOptions={liabilityAccountOptions}
          paymentTypeOptions={paymentTypeOptions}
          charges={charges}
          userData={userData}
          onFinish={onFinish}
          fundCount={fundCount}
          setFundCount={setFundCount}
          feeCount={feeCount}
          setFeeCount={setFeeCount}
          penaltyCount={penaltyCount}
          setPenaltyCount={setPenaltyCount}
          mapFeeTableSource={mapFeeTableSource}
          setMapFeeTableSource={setMapFeeTableSource}
          configureFundTableSource={configureFundTableSource}
          setConfigureFundTableSource={setConfigureFundTableSource}
          chargesOptions={chargesOptions}
          penaltyOptions={penaltyOptions}
          mapPenaltyTableSource={mapPenaltyTableSource}
          setMapPenaltyTableSource={setMapPenaltyTableSource}
        />
      ) : radioChecked === 4 ? (
        <UpfrontAccrualCheckForm
          form={form}
          showAdvanced={showAdvanced}
          setShowAdvanced={setShowAdvanced}
          assetAccountOptions={assetAccountOptions}
          incomeAccountOptions={incomeAccountOptions}
          expenseAccountOptions={expenseAccountOptions}
          liabilityAccountOptions={liabilityAccountOptions}
          paymentTypeOptions={paymentTypeOptions}
          charges={charges}
          userData={userData}
          onFinish={onFinish}
          fundCount={fundCount}
          setFundCount={setFundCount}
          feeCount={feeCount}
          setFeeCount={setFeeCount}
          penaltyCount={penaltyCount}
          setPenaltyCount={setPenaltyCount}
          mapFeeTableSource={mapFeeTableSource}
          setMapFeeTableSource={setMapFeeTableSource}
          configureFundTableSource={configureFundTableSource}
          setConfigureFundTableSource={setConfigureFundTableSource}
          chargesOptions={chargesOptions}
          penaltyOptions={penaltyOptions}
          mapPenaltyTableSource={mapPenaltyTableSource}
          setMapPenaltyTableSource={setMapPenaltyTableSource}
        />
      ) : null}
    </Form>
  );
};

export default AccountingForm;
